import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">McLean Cannabis · Informational Hub</p>
        <h1>Welcome to McLean Cannabis</h1>
        <p className="lede">
          Your go-to source for the latest updates on cannabis policy, culture, and legal status in McLean. 
          Stay informed with our comprehensive coverage and educational resources.
        </p>
        <div className="cta-row">
          <a href="/law-updates" target="_self">
            Latest Law Updates
          </a>
          <a href="/educational-resources" target="_self" className="secondary">
            Explore Educational Content
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Local Cannabis Law Updates</h2>
          <p>
            Stay updated on the evolving cannabis regulations and policies affecting McLean residents. 
            Our coverage provides insights into local legislation and its implications.
          </p>
        </article>
        <article>
          <h2>Understanding Legal Status</h2>
          <p>
            Navigate the complexities of cannabis legality in our area. We offer clear information 
            about what is permitted and what is not, ensuring you stay compliant and informed.
          </p>
        </article>
        <article>
          <h2>Educational Resources</h2>
          <p>
            Access a wealth of knowledge about cannabis culture, its benefits, and responsible use. 
            Our guides and articles are designed to educate and empower the community.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;